import { ACCESSORY_GROUP_APPLIED_CHANNEL } from './enum';

export const ACCESSORY_GROUP_APPLIED_CHANNEL_NAME = Object.freeze({
  [ACCESSORY_GROUP_APPLIED_CHANNEL.BOTH]: 'Offline & Online', // Tất cả kênh
  [ACCESSORY_GROUP_APPLIED_CHANNEL.OFFLINE]: 'Offline', // Kênh offline
});
